import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 9L7.5 6L4.5 3",
		stroke: "#03142E",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronRight;
